export default function Dashboard(vm) {
    this.store = function() {
        var url = '/dashboard/store';

        return vm.get(url);
    };

    this.topStore = function() {
        var url = '/dashboard/top-store';

        return vm.get(url);
    };

    this.monthly = function() {
        var url = '/dashboard/monthly';

        return vm.get(url);
    };
}